import React, { useEffect } from 'react';
import { navigate } from 'gatsby';
import { getAllFlowsPath, getOrderTypeByPath } from '@/helpers/navigation'
import createStore from './src/store';
import paths from '@/helpers/navigation/paths.json';
import SEO from '@/components/SEO';

const wrapPageElement = ({ element, props }) => {
  const { auth: { isLoggedIn } } = createStore.store.getState();

useEffect(()=>{
  const whiteListedUrl = [
    '/mfa',
    '/approve',
    '/approve/success',
    '/tl/approve',
    '/unmask/approve'
  ];

  //for Customer Empower flow, to redirect to /login & store intended flow
  if (window.history?.state === null && props.path !== paths.LOGIN.url && window.localStorage.getItem('udf_token')) {
    const pathUrl = props.path + props.location.search
    if (getAllFlowsPath().includes(pathUrl)) {
      window.localStorage.setItem('customer_flow', getOrderTypeByPath(pathUrl))
    }
  }
  // check to redirect to respective flow
  if (whiteListedUrl.includes(props.path)) {
    navigate(`${props.path}${props.location.search}`) 
  } else if (!isLoggedIn && props.path === paths.STAFF_LOGIN.url) {
    navigate(paths.STAFF_LOGIN.url);
  } else if (!isLoggedIn && props.path !== paths.LOGIN.url) {
    navigate(paths.LOGIN.url);
  }
},[])

  return (
    <>
      <SEO />
      {element}
    </>
  );
};

export default wrapPageElement;
